import $ from 'jquery';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui'; 

class PlayListingFilter {
    constructor(target, settings) {
        
    }

    init() {
        this.filter();
    }
    
    filter() {
        //create state
        let currentFilter = '';

        //create variables
        const filters = $('.filter');
        const plays = $('.plays-section')[0];
        
        const playArr = Array.prototype.slice.call(plays.children);
        const filterArr = Array.prototype.slice.call(filters);

        //create listeners
        filters.on('click', (e) => {
            e.preventDefault();
            let target = e.target.closest('.filter');
            if ($(target).hasClass('active')) {
                currentFilter = '';
                filterArr.forEach(filter => {
                    $(filter).removeClass('active');
                });
            } else {
                currentFilter = $(target).children('.filter-name').text();
                filterArr.forEach(filter => {
                    $(filter).removeClass('active');
                    if ($(filter).children('.filter-name').text() === currentFilter) {
                        $(filter).addClass('active');
                    }
                });
            }
            playArr.forEach(play => {
                play.style.display = 'flex';
                 if (currentFilter === '') {
                    $(play).show();
                } else if ($(play).data('tag') !== currentFilter) {
                   $(play).hide();
                }
            });
        });
    }
}

export default PlayListingFilter;

$(() => {
	const playListingFilter = new PlayListingFilter();
	playListingFilter.init();
});